/**
 * @module Header-Nav-Menus
 */

import { NavLink } from "react-router-dom";
import { stopAnchorNavigation, route } from "../../../../globals/constants";
import { navUrl } from "../../../../globals/common-functions";

/**
 * 
 * @returns Navigation Menus for header section
 */
const SectionHeaderNavMenu = () => {
    return (
        <ul className=" nav navbar-nav">
            {/* <li className="has-child">
                <a href="!#" style={stopAnchorNavigation}>Home</a>
                <ul className="sub-menu">
                    <li><NavLink to={route.home.HOME1}>Home 1</NavLink></li>
                    <li><NavLink to={route.home.HOME2}>Home 2</NavLink></li>
                    <li><NavLink to={route.home.HOME3}>Home 3</NavLink></li>
                </ul>
            </li> */}
               <li><a href={"#home"}>Home</a></li>
            <li><a  href={"/#about"}>About</a></li>
            <li><a  href={"/#services"}>Services</a></li>
            <li><a href={"/#whyus"}>Why Us</a></li>
            {/* <li className="has-child">
                <a href="!#" style={stopAnchorNavigation}>Services</a>
                <ul className="sub-menu">
                    <li><NavLink to={navUrl.services(route.services.SERVICES)}>Services</NavLink></li>
                    <li><NavLink to={navUrl.services(route.services.DETAIL)}>Services Detail</NavLink></li>
                </ul>
            </li>
            <li className="has-child">
                <a href="!#" style={stopAnchorNavigation}>Pages</a>
                <ul className="sub-menu">
                    <li><NavLink to={navUrl.pages(route.pages.CASE_STUDY)}>Case Study</NavLink></li>
                    <li><NavLink to={navUrl.pages(route.pages.CASE_DETAIL)}>Case Detail</NavLink></li>
                    <li><NavLink to={navUrl.pages(route.pages.TESTIMONIALS)}>Clients</NavLink></li>
                    <li><NavLink to={navUrl.pages(route.pages.FAQ)}>FAQ</NavLink></li>
                    <li><NavLink to={navUrl.pages(route.pages.PLANS)}>Pricing Plan</NavLink></li>
                    <li><NavLink to={navUrl.pages(route.pages.TEAM)}>Our Team</NavLink></li>
                </ul>
            </li>
            <li className="has-child">
                <a href="!#" style={stopAnchorNavigation}>Blog</a>
                <ul className="sub-menu">
                    <li><NavLink to={navUrl.blogs(route.blogs.BLOGS)}>Blog</NavLink></li>
                    <li><NavLink to={navUrl.blogs(route.blogs.STANDARD)}>Blog Standard</NavLink></li>
                    <li><NavLink to={navUrl.blogs(route.blogs.LEFT_SIDEBAR)}>Blog Left Sidebar</NavLink></li>
                    <li><NavLink to={navUrl.blogs(route.blogs.DETAIL)}>Blog Detail</NavLink></li>
                </ul>
            </li> */}
            {/* <li><NavLink to={navUrl.pages(route.pages.CONTACT)}>Contact</NavLink></li> */}
        </ul>
    )
}
export default SectionHeaderNavMenu;